import React, { useEffect, useState } from 'react';

// A 1x1 transparent GIF — swapped in on error so the element stays a real,
// successfully-"loaded" <img> (cards style this by element type, e.g.
// `.__artist_single img`) instead of an empty/invalid src, which Chromium
// renders with its own broken-image icon and alt text on top of our placeholder.
const BLANK_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ycQAgAAAAAAAAAAACwAAAAAAAABAAAAAgQAADs=';

// Shimmers (the .imageLoader class, see globalstyles.scss) while the image is
// loading. Without this, a missing/broken photo (common for lesser-known
// artists/movies) left the shimmer animating forever, reading as a stuck
// "still loading" page instead of "no photo available".
const ImageLoader = ({ src, alt = '', className = '', ...rest }) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    return (
        <img
            src={failed ? BLANK_PIXEL : src}
            alt={failed ? '' : alt}
            className={`imageLoader ${failed ? 'is-missing' : ''} ${className}`.trim()}
            onError={() => setFailed(true)}
            {...rest}
        />
    );
};

export default ImageLoader;
